import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_PANELS,
    FETCH_PANELS_FAILURE,
    FETCH_PANELS_SUCCESS,
    FETCH_PANEL_BRANDS,
    FETCH_PANEL_BRANDS_FAILURE,
    FETCH_PANEL_BRANDS_SUCCESS,
    FETCH_ROOF_TYPES,
    FETCH_ROOF_TYPES_FAILURE,
    FETCH_ROOF_TYPES_SUCCESS,
    FETCH_SYSTEM_TYPES,
    FETCH_SYSTEM_TYPES_FAILURE,
    FETCH_SYSTEM_TYPES_SUCCESS,
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
    INITIALIZE_VALUES,
    RESET,
    RESET_FORM,
    SAVE_PROPOSAL,
    SAVE_PROPOSAL_SUCCESS,
    SAVE_PROPOSAL_FAILURE,
    SET_IS_NEW_RECORD,
    SET_IS_OPEN_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    initialValues: {
        id: null,
        name: '',
        panel: '',
        panel_brand: '',
        project: null,
        type: 'pro',
    },
    isInitializing: false,
    isNewRecord: false,
    isOpenModal: false,
    panels: {
        data: [],
        errors: [],
        isFetching: false,
    },
    panelBrands: {
        data: [],
        errors: [],
        isFetching: false,
    },
    roofTypes: {
        data: [],
        errors: [],
        isFetching: false,
    },
    saveProposal: {
        isSaving: false,
        errors: [],
    },
    systemTypes: {
        data: [],
        errors: [],
        isFetching: false,
    },
};

const createProposalModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_PANELS]: (state) => {
            state.panels = {
                ...state.panels,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PANELS_FAILURE]: (state, action) => {
            state.panels = {
                ...state.panels,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANELS_SUCCESS]: (state, action) => {
            state.panels = {
                ...state.panels,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANEL_BRANDS]: (state) => {
            state.panelBrands = {
                ...state.panelBrands,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PANEL_BRANDS_FAILURE]: (state, action) => {
            state.panelBrands = {
                ...state.panelBrands,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANEL_BRANDS_SUCCESS]: (state, action) => {
            state.panelBrands = {
                ...state.panelBrands,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROOF_TYPES]: (state) => {
            state.roofTypes = {
                ...state.roofTypes,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ROOF_TYPES_FAILURE]: (state, action) => {
            state.roofTypes = {
                ...state.roofTypes,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROOF_TYPES_SUCCESS]: (state, action) => {
            state.roofTypes = {
                ...state.roofTypes,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_SYSTEM_TYPES]: (state) => {
            state.systemTypes = {
                ...state.systemTypes,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_SYSTEM_TYPES_FAILURE]: (state, action) => {
            state.systemTypes = {
                ...state.systemTypes,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_SYSTEM_TYPES_SUCCESS]: (state, action) => {
            state.systemTypes = {
                ...state.systemTypes,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE]: (state) => {
            state.isInitializing = true;
        },
        [INITIALIZE_FAILURE]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_SUCCESS]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE_PROPOSAL]: (state) => {
            state.saveProposal = {
                ...state.saveProposal,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PROPOSAL_FAILURE]: (state, action) => {
            state.saveProposal = {
                ...state.saveProposal,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PROPOSAL_SUCCESS]: (state, action) => {
            state.saveProposal = {
                ...state.saveProposal,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [SET_IS_OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
    },
});

export const createProposalModalActions = createProposalModalSlice.actions;

export default createProposalModalSlice.reducer;
